"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WIDGETS = {
    "de": "/assets/images/de-pass-woman.jpeg",
    "en-us": "/assets/images/en-us-pass-woman.jpeg",
    "en-gb": "/assets/images/en-gb-pass-woman.jpeg",
    "fr-fr": "/assets/images/fr-pass-woman.jpeg",
    "es-es": "/assets/images/es-pass-woman.jpeg",
    "it": "/assets/images/it-pass-woman.jpeg",
    default: "/assets/images/en-pass-woman.jpeg",
};
function getWidgetBackgroundUrl() {
    var _a;
    var landing = location.pathname.split('/')[1];
    return (_a = WIDGETS[landing]) !== null && _a !== void 0 ? _a : WIDGETS.default;
}
exports.default = getWidgetBackgroundUrl;
